import { Button, Typography } from 'antd';
import Wrapper from './Wrapper';
import { useAppDispatch } from 'app/hooks';
import { logoutAction } from 'actions/auth';
import { translate } from 'libs';

const LinkExpiredPage = () => {
  const dispatch = useAppDispatch();

  const handleOk = () => dispatch(logoutAction());

  return (
    <Wrapper>
      <div className="lock-block">
        <div>
          <div>
            <div className="block-ip-icon">
              <img src="/images/ic-link-expired.png" alt="Link Expired" />
            </div>
            <div>
              <Typography.Text className="txt-title">
                {translate('loginPage.linkExpiredAlert')}
              </Typography.Text>
            </div>
            <div className="description">
              <Typography.Text className="txt-description">
                {translate('loginPage.linkExpiredDescription1')}
              </Typography.Text>
            </div>
            <div className="description">
              <Typography.Text className="txt-description">
                {translate('loginPage.linkExpiredDescription2')}
              </Typography.Text>
            </div>
            <Button type="primary" block size="large" className="btn-ok" onClick={handleOk}>
              {translate('common.ok2')}
            </Button>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default LinkExpiredPage;
